import type { ReaderPdfPageMap, ReaderPdfPageMapEntry } from "@/interface/DTO_Interfaces"
import { getContentJson } from "@/ts/api/content"
import { pStore } from "@/ts/storage/store"

const isPageMapEntry = (value: unknown): value is ReaderPdfPageMapEntry => {
        if (!value || typeof value !== "object") return false

        const entry = value as Partial<ReaderPdfPageMapEntry>

        if (!Number.isInteger(entry.sourcePageNumber) || Number(entry.sourcePageNumber) < 1) return false

        const isSinglePage = Number.isInteger(entry.pageNumber) && Number(entry.pageNumber) > 0
                && entry.left === undefined && entry.right === undefined
        const isSpread = entry.pageNumber === undefined
                && Number.isInteger(entry.left) && Number(entry.left) > 0
                && Number.isInteger(entry.right) && Number(entry.right) > 0

        return isSinglePage || isSpread
}

export const loadPdfPageMap = async (src: string): Promise<ReaderPdfPageMap> => {
        const value = await getContentJson<unknown>(src, "Не удалось загрузить карту страниц PDF")

        if (!value || typeof value !== "object" || !("pages" in value) || !Array.isArray(value.pages)
                || value.pages.length === 0 || !value.pages.every(isPageMapEntry)
                || new Set(value.pages.map((entry) => entry.sourcePageNumber)).size !== value.pages.length) {
                throw new Error("Некорректный формат карты страниц PDF")
        }

        return { pages: value.pages }
}

export const getPrintedPageNumber = (sourcePageNumber: number, side: "left" | "right") => {
        const entry = pStore().pageMap.pages.find((item) => item.sourcePageNumber === sourcePageNumber)

        return entry?.pageNumber ?? entry?.[side]
}

export const getSourcePageLocation = (printedPageNumber: number, preferredSourcePageNumber = 1) =>
        pStore().pageMap.pages
                .flatMap((entry) => [
                        ...(entry.pageNumber === printedPageNumber ? [{ sourcePageNumber: entry.sourcePageNumber, side: "left" as const }] : []),
                        ...(entry.left === printedPageNumber ? [{ sourcePageNumber: entry.sourcePageNumber, side: "left" as const }] : []),
                        ...(entry.right === printedPageNumber ? [{ sourcePageNumber: entry.sourcePageNumber, side: "right" as const }] : []),
                ])
                .sort((left, right) => Math.abs(left.sourcePageNumber - preferredSourcePageNumber) - Math.abs(right.sourcePageNumber - preferredSourcePageNumber))[0] ?? null
